import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Offcanvas, OffcanvasBody } from "reactstrap";
import userIcon from "../../assets/icons/user-icon-menu.svg";
import "./sidebar.css";
import { t } from "i18next";
import {
  clearUserAccessBuilding,
  clearUserAccessOpeningAndBuilding,
  getDataUserByKey,
  getTenantInfoByKey,
  getUserBuilding,
  getUserOpening,
  havePermission,
} from "../../helpers/helpers";
import SidebarOption from "./SidebarOption";
import { sidebarMenu } from "./sidebarMenu";
import useWindowSize from "../../customHooks/useWindowSize";
import { logout } from "../../services/login";
import InstanceContext from "../../context/InstanceContext/InstanceContext";
import buildingIcon from "../../assets/icons/building-black-icon.svg";

const Sidebar = ({ isOpen, setIsOpen }) => {
  const { isReadyForInstall, downloadApp } = useContext(InstanceContext);
  const navigate = useNavigate();

  const profile_id = getDataUserByKey("access_profile_id");
  const isGuard = Number(profile_id) === 3;

  const haveAccessOpenings = getTenantInfoByKey("is_access_opening");

  const haveAccessBuildings = getTenantInfoByKey("is_building");

  const fullName = `${getDataUserByKey("first_name")} ${getDataUserByKey(
    "last_name"
  )}`;

  const isVisible = (permissions) =>
    permissions.length === 0
      ? true
      : permissions.some((permission) => havePermission(permission));

  const { windowWidth } = useWindowSize();

  const logoutOpt = {
    key: "LOGGOUT",
    icon: "loggout-icon.svg",
    onClick: () => logout(),
    onScreen: "",
    isVisibleFor: [],
  };

  const downloadAppOpt = {
    key: "DOWNLOAD_APP",
    icon:
      windowWidth <= 576
        ? "download-app-phone.svg"
        : "download-app-desktop.svg",
    onClick: () => downloadApp(),
    onScreen: "",
    isVisibleFor: [],
  };

  return (
    <Offcanvas isOpen={isOpen} direction="end" toggle={setIsOpen}>
      <div className="d-flex flex-column w-100 p-2">
        <div className="me-2 d-flex align-items-center gap-2">
          <img src={userIcon} alt="profile" />
          <div>
            <p className="m-0 hello-txt">{t("HELLO")}</p>
            <p className="m-0 fullname-txt">{fullName}</p>
          </div>
        </div>
        <div className="w-100">
          {isGuard && (
            <>
              {haveAccessOpenings && (
                <>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <hr
                      style={{
                        width: "40px",
                        border: "none",
                        borderTop: "2px solid var(--gray-500)",
                        margin: "8px 0",
                      }}
                    />
                  </div>

                  <div className="sidebar-guard-context d-flex align-items-center justify-content-between gap-2 mt-1 w-100">
                    <div
                      className="sidebar-guard-card rounded-3 border w-100 p-2 d-flex align-items-center justify-content-between"
                      style={{ background: "#FFFF" }}
                      type="button"
                      onClick={() => {
                        clearUserAccessOpeningAndBuilding();
                        setIsOpen(false);
                        navigate("/selectAccessOpening", {
                          state: {
                            hideNavbarWelcome: true,
                            accessSelectionFromSidebar: "opening",
                          },
                        });
                      }}
                    >
                      <div className="sidebar-guard-card-left">
                        <div className="sidebar-guard-icon">
                          <i className="fa fa-solid fa-map-marker-alt d-block gray-800-color"></i>
                        </div>
                        <div className="sidebar-guard-text">
                          <p
                            className="m-0 gray-700-color"
                            style={{ fontSize: "12px" }}
                          >
                            {getTenantInfoByKey("opening_name")}
                          </p>
                          <p
                            className="m-0 gray-900-color fw-bold"
                            style={{ fontSize: "14px" }}
                          >
                            {getUserOpening()?.descripcion}
                          </p>
                        </div>
                      </div>
                      <i
                        style={{ color: "#98A0B6", fontSize: "14px" }}
                        className="fa fa-solid fa-sync d-block"
                      ></i>
                    </div>
                  </div>
                </>
              )}
              {haveAccessBuildings && (
                <>
                  {!haveAccessOpenings && (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <hr
                        style={{
                          width: "40px",
                          border: "none",
                          borderTop: "2px solid var(--gray-500)",
                          margin: "8px 0",
                        }}
                      />
                    </div>
                  )}

                  <div className="sidebar-guard-context d-flex align-items-center justify-content-between gap-2 mt-1 w-100">
                    <div
                      className="sidebar-guard-card rounded-3 border w-100 p-2 d-flex align-items-center justify-content-between"
                      style={{ background: "#FFFF" }}
                      type="button"
                      onClick={() => {
                        clearUserAccessBuilding();
                        setIsOpen(false);
                        navigate("/selectAccessBuildings", {
                          state: {
                            hideNavbarWelcome: true,
                            accessSelectionFromSidebar: "building",
                          },
                        });
                      }}
                    >
                      <div className="sidebar-guard-card-left">
                        <div className="sidebar-guard-icon">
                          <img
                            src={buildingIcon}
                            style={{ width: "25px", height: "25px" }}
                            alt=""
                          />
                        </div>
                        <div className="sidebar-guard-text">
                          <p
                            className="m-0 gray-700-color"
                            style={{ fontSize: "12px" }}
                          >
                            {getTenantInfoByKey("building_name")}
                          </p>
                          <p
                            className="m-0 gray-900-color fw-bold"
                            style={{ fontSize: "14px" }}
                          >
                            {getUserBuilding()?.buildingDescription}
                          </p>
                        </div>
                      </div>
                      <i
                        style={{ color: "#98A0B6", fontSize: "14px" }}
                        className="fa fa-solid fa-sync d-block"
                      ></i>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <hr
          style={{
            width: "40px",
            border: "none",
            borderTop: "2px solid var(--gray-500)",
            margin: "8px 0",
          }}
        />
      </div>

      <OffcanvasBody>
        {sidebarMenu.map(
          (sidebarOption, idx) =>
            isVisible(sidebarOption.isVisibleFor) && (
              <SidebarOption
                key={idx}
                closeSidebar={() => setIsOpen(false)}
                sidebarOption={sidebarOption}
              />
            )
        )}
        {isReadyForInstall && (
          <SidebarOption
            closeSidebar={() => setIsOpen(false)}
            sidebarOption={downloadAppOpt}
          />
        )}
        <SidebarOption
          closeSidebar={() => setIsOpen(false)}
          sidebarOption={logoutOpt}
        />
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default Sidebar;
